import $store from '@/store.js'
import Tool from '@/assets/js/utils.js'
const { protocol } = window.location
// 加载serviceList.js并存储全局变量供media及公共header使用   已经调用
function loadSudoku (data, session) {
  window.serviceList = {
    userseviceUrl: `${protocol}//${data.userservice}`,
    session,
    menuInterfaceUrl: `${protocol}//${data.menuListInterfaceUrl}`, // 用于公共头部接口
    shareUrl: `${protocol}//${data.shareServerUrl}`, // 用于header
    mediaApiUrl: `${protocol}//${data.mediaApiUrl}`, // 用于media接口
    mediaServerUrl: `${protocol}//${data.mediaServerUrl}`, // 用于media js
    blobUrl: `${protocol}//${data.blobUrl}`,
    menuServerUrl: `${protocol}//${data.menuServerUrl}`,
    userserviceApi: `${protocol}//${data.userAuthUrl}`, // "cc-ms-dev.tvunetworks.com/userAuth"， userauth地址 （可按照服务后端配置自行绑定）
    newUserServiceUrl: `${protocol}//${data.serviceListUrl}` // "cc-ms-dev.tvunetworks.com/serviceListUI"，

  }
  // document.write(`<script type="text/javascript" src="${protocol}//${data.serviceListUrl}/package.serviceList/serviceList.v2.js" ></script>`)
  if ($store.state.common.baseUrl.gtagTvu) initTvuGtag()
  if ($store.state.common.baseUrl.gtagChannel) initChannelGtag()
  if ($store.state.common.baseUrl.googleAnalyticsAccount) initGoogleAnalytics()
  initGoogleManager()
  initGoogleManagerIframe()
}
// 谷歌分析
function initChannelGtag () {
  ((h, o, t, j, a, r) => {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', $store.state.common.baseUrl.gtagChannel)
  window.dataLayer = window.dataLayer || []

  function gtag () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', $store.state.common.baseUrl.gtagChannel)
}
// gtag记录
function initTvuGtag () {
  // Global site tag (gtag.js) - Google Analytics
  ((h, o, t, j, a, r) => {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', $store.state.common.baseUrl.gtagTvu)
  window.dataLayer = window.dataLayer || []

  function gtag () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', $store.state.common.baseUrl.gtagTvu)
}
// Google Tag Manager
function initGoogleManager () {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    const f = d.getElementsByTagName('head')[0]
    const j = d.createElement(s)
    const dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.appendChild(j)
  })(window, document, 'script', 'dataLayer', 'GTM-MD8F2BK')
}
// Google Tag Manager (noscript)
function initGoogleManagerIframe () {
  (function (d, s, i) {
    const f = d.getElementsByTagName('body')[0]
    const j = d.createElement(s)
    j.height = 0
    j.width = 0
    j.style = 'display:none;visibility:hidden'
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i
    f.appendChild(j)
  })(document, 'iframe', 'GTM-MD8F2BK')
}
// 谷歌分析
function initGoogleAnalytics () {
  ((h, o, t, j, a, r) => {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.google-analytics.com/analytics.js?id=', $store.state.common.baseUrl.googleAnalyticsAccount)
  window.dataLayer = window.dataLayer || []

  function gtag () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', $store.state.common.baseUrl.googleAnalyticsAccount)
}
// 加载language的js文件
const loadLanguageJs = () => {
  const jsUrl = `${protocol}//${$store.state.common.baseUrl.languageUrl}/langConfig.js`
  document.write(`<script type="text/javascript" src=${jsUrl} ></script>`)
  isCompleteLoad()
  // Tool.dynamicLoadJs(jsUrl, function() {
  //     $store.state.common.hasInitLang = true;
  //     loadHeaderJs();
  // });
}
const isCompleteLoad = () => {
  if (typeof langConfig != 'undefined') {
    $store.state.common.hasInitLang = true
  } else {
    setTimeout(() => {
      isCompleteLoad()
    }, 100)
  }
}
// 加载headerConfig
function loadHeaderJs () {
  // let cssUrl = `http://local.tvunetworks.com:8000/headerConfig.min.css`;
  const cssUrl = `${protocol}//${$store.state.common.baseUrl.menuServerUrl}/headerConfig.min.css`
  const jsUrl = `${protocol}//${$store.state.common.baseUrl.menuServerUrl}/headerConfig.js`
  // let jsUrl = `http://local.tvunetworks.com:8000/headerConfig.js`;
  Tool.includeLinkStyle(cssUrl)
  Tool.dynamicLoadJs(jsUrl, () => {
    const timers = setInterval(() => {
      try {
        if (langConfig) {
          // let lang = langConfig.langValue || window.localStorage.getItem('lang') || navigator.language || navigator.userLanguage;
          clearInterval(timers)
          // window.headerObj = new headerTemplate(lang, session);
        }
      } catch (err) {

      }
    }, 10)
  })
}
// 加载mediaCommon
function loadMediaJs (callback) {
  // 若当前js界面中已存在，则无需加载
  if ($('#mediaCommon').length > 0 && typeof (callback) == 'function') {
    callback()
  } else {
    const url = `${protocol}//${$store.state.common.baseUrl.mediaServerUrl}/js/mediaCommon.js`
    // const url = 'https://local.tvunetworks.com:8888/js/mediaCommon.js'
    Tool.dynamicLoadJs(url, () => {
      if (typeof (callback) == 'function') {
        callback()
      }
    }, 'mediaCommon')
  }
}
// 加载illingJs，集成订阅功能
function loadBillingJs (callback) {
  // 若当前js界面中已存在，则无需加载
  if ($('#BillingServiceIframe').length > 0 && typeof (callback) == 'function') {
    callback()
  } else {
    const url = `${protocol}//${$store.state.common.baseUrl.billingFrontUrl}/js/billing.js`
    // const url = 'https://cc-ms-dev.tvunetworks.com/billing/js/billing.js'
    Tool.dynamicLoadJs(url, () => {
      if (typeof (callback) == 'function') {
        callback()
      }
    }, 'BillingServiceIframe')
  }
}
function loadVersionNews (data, session, callback) {
  window.versionNewsObj = {
    code: data.versionCode, // service标识（必填）
    pageSize: 10, // 每页显示数据（选填，默认为10条/页）
    versionUrl: `${protocol}//${data.versionUrl}`, // versionNews JS服务地址（必填）
    versionApiUrl: `${protocol}//${data.versionApiUrl}`, // 接口地址（必填）
    session, // （必填）
    theme: 'black', // 主题颜色black（选填，默认为black，可选white
    rightWidth: '125px'
  }
  // document.write(`<script type="text/javascript" src="${protocol}//${data.versionUrl}/versionNews.js" ></script>`)
  // 若当前js界面中已存在，则无需加载
  // if ($('#VersionNewsJs').length > 0 && typeof (callback) == 'function') {
  //   callback()
  // } else {
  //   const url = `${protocol}//${data.versionUrl}/versionNews.js`
  //   Tool.dynamicLoadJs(url, () => {
  //     if (typeof (callback) == 'function') {
  //       callback()
  //     }
  //   }, 'VersionNewsJs')
  // }
}
export {
  loadSudoku,
  loadMediaJs,
  loadHeaderJs,
  loadLanguageJs,
  loadBillingJs,
  loadVersionNews
}
